import { removeSnapshotCache } from './removeSnapshotCache';
export function configureProtectedFile(informationProtectionService, resolvedUrl, partitionKey, mipCache, tracker) {
    tracker?.markSubActivityStart('ConfigureProtectedFile');
    const onProtectionChanged = (isProtectionEnabled) => {
        if (isProtectionEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            removeSnapshotCache(resolvedUrl, partitionKey);
        }
    };
    // Update the hasProtection from cache if available
    if (mipCache?.hasProtection) {
        onProtectionChanged(mipCache.hasProtection);
    }
    informationProtectionService.on('protectionChanged', onProtectionChanged);
    informationProtectionService
        .getHasProtection(resolvedUrl)
        .then((hasProtection) => {
        if (hasProtection) {
            onProtectionChanged(hasProtection);
        }
    })
        .catch(() => { });
    tracker?.markSubActivityEnd('ConfigureProtectedFile');
}
//# sourceMappingURL=configureProtectedFile.js.map